module.exports = __webpack_public_path__ + "assets/img/1_1665_big.58170333.jpg";